import { BasicError, MuiNavLink } from "../_Misc";
import { useHomeHub } from "../../services/backend";
import makeStyles from "@mui/styles/makeStyles";
import { Scroller } from "./Scroller";
import { PosterCard, PosterCardSkeletonRow } from "../Cards";
import { buildAssetUrl } from "../../utils";
import { generatePath } from "react-router-dom";
import ShowMore from "./ShowMore";
import { links } from "../../constants";

export const RecentPeopleHub = () => {
  const { data, error, isLoading } = useHomeHub();
  const classes = useStyles();

  if (error) return <BasicError error={error?.message} />;
  // if (!data) return <Spinner />;

  const recent_people = data?.recent_people;
  if (recent_people?.length === 0) return <></>;

  const uid = "people_hub";
  return (
    <div>
      <Scroller
        uid={uid}
        title={
          <span>
            Recently Added{" "}
            <MuiNavLink to={links.people} underline="hover">
              Actors
            </MuiNavLink>
          </span>
        }
      >
        {isLoading ? (
          <PosterCardSkeletonRow uid={uid} />
        ) : (
          <>
            {recent_people?.map((person) => {
              const image_url = buildAssetUrl(person.cloudinary_path, "f_auto,h_500,w_333");
              return (
                <div className={classes.wrapper} key={`HUB_PERSON_${person.slug}`}>
                  <PosterCard
                    alt={""}
                    image_url={image_url}
                    link={generatePath(links.person, { id: person.slug })}
                    title={person.name}
                  />
                </div>
              );
            })}
            <ShowMore href={generatePath(links.people)} />
          </>
        )}
      </Scroller>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: { marginRight: theme.spacing(4) },
}));
